module.exports = __webpack_public_path__ + "media/stylesheets/images/media/banner_kurashino-f50d58e389eda68de7346988a470ed3e.jpg";